/**
 * Aparicion suave de las secciones al entrar en pantalla.
 *
 * El estado oculto lo activa este modulo marcando cada seccion con data-reveal,
 * nunca el CSS por si solo: si el JS no llega a ejecutarse, o si el navegador
 * no soporta IntersectionObserver, la pagina se ve entera igualmente. Esto
 * importa en los navegadores integrados de TikTok e Instagram, que es de donde
 * llega casi todo el trafico.
 *
 * Solo se animan `opacity` y `translate`, que el movil mueve sin despeinarse.
 */

const REDUCIR_MOVIMIENTO = '(prefers-reduced-motion: reduce)';

function activar() {
  if (window.matchMedia(REDUCIR_MOVIMIENTO).matches) return;
  if (!('IntersectionObserver' in window)) return;

  const principal = document.getElementById('MainContent');
  const secciones = principal?.querySelectorAll(':scope > .shopify-section');
  if (!secciones?.length) return;

  const observador = new IntersectionObserver(
    (entradas) => {
      for (const entrada of entradas) {
        if (!entrada.isIntersecting) continue;
        entrada.target.setAttribute('data-revealed', '');
        observador.unobserve(entrada.target);
      }
    },
    { rootMargin: '0px 0px -6% 0px', threshold: 0.02 }
  );

  secciones.forEach((seccion, indice) => {
    // La primera pantalla no se anima: hacerlo solo retrasaria el contenido
    // que el cliente ha venido a ver.
    if (indice === 0) return;
    seccion.setAttribute('data-reveal', '');
    observador.observe(seccion);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', activar, { once: true });
} else {
  activar();
}
